import DOMPurify from 'dompurify';
 

function BoxedTextBox(obj) {
    let title = obj.title,
        text = obj.text,
        containerClasses = ' tw-max-w-screen-lg  tw-m-auto ',
        checkIcon = '<span style="display:inline-block;height:1.5rem; width: 1.5rem;flex:none;margin-right: .5rem"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" class="w-6 h-6 tw-text-teal"><path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg></span>';
        console.log('BoxedTextBox', obj)
        
    return(
            <div className={"tw-mb-10 lg:tw-mb-3 tw-p-5 md:tw-p-0 xmd:tw-flex "+containerClasses}>
              <div className={"tw-flex-none tw-px-6 tw-py-6 tw-rounded-2xl md:tw-py-12 tw-bg-gray-light xmd:tw-w-1/4 xmd:tw-mr-3 xmd:tw-mb-0 tw-mb-2 tw-align-middle"}>
                <h2 className="tw-font-condensed tw-font-black tw-text-xl md:tw-text-3xl tw-uppercase">
                    {title}
                </h2>
              </div>
              <div className={"tw-flex-1 tw-px-6 tw-py-6 tw-rounded-2xl md:tw-py-12 tw-bg-gray-light "}>
                <div className="tw-mb-6 mb-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text.replace(RegExp(/<li>/ig), '<li style="vertical-align: baseline;display: flex;">'+checkIcon)) }}/>
              </div>
            </div>
    );
}


export default BoxedTextBox;